import { User } from '@willow/graphql-iso/src/app';

export function getUserName<T extends Pick<User, 'firstName' | 'lastName' | 'email'>>(user: T): string {
  return user.firstName && user.lastName ? `${user.firstName} ${user.lastName}` : user.email;
}
